import React from 'react';
export function Footer() {
  return <footer className="py-8 bg-background border-t border-white/5 text-center" role="contentinfo" data-id="element-103">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-104">
        <div className="mb-8" data-id="element-105">
          <h3 className="text-2xl font-bold text-white mb-2" data-id="element-106">
            🔧 MEGAPACK HERRERÍA BLINDADA
          </h3>
          <p className="text-gold font-medium mb-2" data-id="element-107">
            El sistema N°1 para herreros y dueños de taller en Argentina.
          </p>
          <p className="text-gray-400" data-id="element-108">
            Porque trabajar en herrería no debería costarte material perdido,
            presupuestos sin ganancia real y clientes que no entienden el valor
            de tu trabajo.
          </p>
        </div>

        <div className="border-t border-white/5 pt-8" data-id="element-109">
          <p className="text-gray-500 text-sm mb-6" data-id="element-110">
            © MegaPack Herrería Blindada™ 2026 — Todos los derechos
            reservados. Prohibida la reproducción y redistribución sin
            autorización expresa.
          </p>
          <div className="text-gray-600 text-sm italic space-y-1" data-id="element-111">
            <p data-id="element-112">🔧 "Desde hoy, tu taller tiene sistema."</p>
          </div>
        </div>
      </div>
    </footer>;
}